(function(){
  var SVG='<svg viewBox="-90 -90 1718 1180" preserveAspectRatio="xMidYMid meet" role="img" aria-label="KIVI" style="height:30px;width:auto;display:block;overflow:visible"><g transform="translate(0,750) scale(1,-1)"><g fill="currentColor"><path transform="translate(-100,0)" d="M100 465 490 670 474 700 136 526V700H100ZM100 257V0H136V234L313 320L505 0L535 18L324 370Z"/><path transform="translate(510,0)" d="M100 0H136V700H100Z"/><path transform="translate(781,0)" d="M546 687 511 700 293 95 75 700 40 687 288 0H298Z"/><path transform="translate(1402,0)" d="M100 0H136V700H100Z"/></g></g></svg>';

  function place(){
    var links=document.querySelectorAll('header a, .header a, [class*="header"] a');
    for(var i=0;i<links.length;i++){
      var a=links[i];
      var txt=(a.textContent||'').trim();

      /* logo linksboven */
      if(!a.dataset.kvlogo && !a.querySelector('img') && !a.querySelector('svg') && txt.toUpperCase()==='KIVI'){
        a.dataset.kvlogo='1';
        a.innerHTML=SVG;
        a.setAttribute('aria-label','KIVI');
        a.style.display='inline-flex';
        a.style.alignItems='center';
        a.style.color='#1A1B1E';
        continue;
      }

      /* shoplink laten opvallen */
      if(!a.dataset.kvshop){
        var href=a.getAttribute('href')||'';
        if(href.indexOf('/products/')>-1 && txt.length>0 && txt.length<24 && !a.querySelector('img')){
          a.dataset.kvshop='1';
          a.classList.add('kvshoplink');
        }
      }
    }
  }
  place();
  document.addEventListener('DOMContentLoaded',place);
  addEventListener('load',place);
  setTimeout(place,250);
  setTimeout(place,900);
  setTimeout(place,2000);
})();
